<template>
  <div class="c-notifications">
    <label
      @mouseover="blockMenu(true)" @mouseleave="blockMenu(false)"
      :for="`notifications-dropdown-${ device }`"
      class="c-notifications__bell">
      <i class="iconf-bell fs-21 d-flex align-items-center"></i>
      <span
        v-if="unreadNotifications != 0"
        class="c-notifications__buble d-flex justify-content-center align-items-center"
      >
        {{ unreadNotifications }}
      </span>
    </label>
    <input
      v-model="switcher" :id="`notifications-dropdown-${ device }`"
      type="checkbox"
      class="d-none"
    >
    <div
      @mouseover="blockMenu(true)"
      @mouseleave="blockMenu(false)"
      class="c-notifications__dropdown"
    >
      <section ref="notifications" @scroll="handleScroll" class="c-notifications__group h-100 py-4">
        <h3 class="mb-4 px-3 px-lg-4 w-bold fs-21 darks">Notificaciones</h3>
        <div v-if="recents.length > 0" class="mb-4">
          <h4 class="mb-3 px-3 px-lg-4 w-bold fs-18 darks">Recientes</h4>
          <ul class="c-notifications__list ul-reset">
            <a
              v-for="(notification, index) of recents"
              :key="index"
              href="#"
              class="c-notification d-flex p-3 px-lg-4 pointer"
              :class="{'read' : notification.status}"
              @click="readNotification(notification)"
            >
              <div class="c-notification__avatar position-relative me-3">
                <figure>
                  <img class="of--cover w-100 h-100" :src="notification.avatar" alt="" />
                </figure>
                <span class="c-notification__badge position-absolute">
                  <i
                    class="d-flex align-items-center"
                    :class="notificationClass(notification.type)"
                  >
                  </i>
                </span>
              </div>
              <div>
                <p class="c-notification__content" v-html="notification.message"></p>
                <div class="pri-color d-flex align-items-center">
                  <i class="iconf-clock me-2 d-flex align-items-center"></i>
                  <span class="fs-14">{{ notification.date }}</span>
                </div>
              </div>
            </a>
          </ul>
        </div>
        <div v-if="ancients.length > 0" class="mb-4">
          <h4 class="mb-3 px-3 px-lg-4 w-bold fs-18 darks">Antiguos</h4>
          <ul class="c-notifications__list ul-reset">
            <a
              v-for="(notification, index) of ancients"
              :key="index"
              href="#"
              class="c-notification d-flex p-3 px-lg-4 pointer"
              :class="{'read' : notification.status}"
              @click="readNotification(notification)"
            >
              <div class="c-notification__avatar position-relative me-3">
                <figure>
                  <img class="of--cover w-100 h-100" :src="notification.avatar" alt="" />
                </figure>
                <span class="c-notification__badge position-absolute">
                  <i
                    class="d-flex align-items-center"
                    :class="notificationClass(notification.type)"
                  >
                  </i>
                </span>
              </div>
              <div>
                <p class="c-notification__content" v-html="notification.message"></p>
                <div class="pri-color d-flex align-items-center">
                  <i class="iconf-clock me-2 d-flex align-items-center"></i>
                  <span class="fs-14">{{ notification.date }}</span>
                </div>
              </div>
            </a>
          </ul>
        </div>
        <div
          ref="loader"
          class="c-notifications__loading d-flex justify-content-center align-items-center mt-4"
        >
          <img
            v-if="hasMoreNotifications && isLoading"
            src="../assets/images/animations/spinner-medium.svg" alt="loading"
          />
          <p v-else>No hay más notificaciones.</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Notifications',
  data() {
    return {
      switcher: false,
      isActiveMenu: false,
      requestNotificationsState: 'standby',
      recents: [],
      ancients: [],
      pagination: {
        perPage: 10,
      },
      hasMoreNotifications: true,
      currentNotificationsIds: '',
      isLoading: false,
    };
  },
  props: ['body', 'device'],
  mounted() {
    if (this.body.id) {
      this.getNotifications();
    }
  },
  computed: {
    unreadNotifications() {
      const recentsUnread = this.recents.filter((notification) => !notification.status);
      const ancientsUnread = this.ancients.filter((notification) => !notification.status);
      const unread = recentsUnread.concat(ancientsUnread);

      return unread.length > 9 ? '9+' : unread.length;
    },
  },
  watch: {
    switcher() {
      document.onclick = () => {
        this.unblockMenu();
      };
    },
  },
  methods: {
    notificationClass(type) {
      let notificationType = '';

      if (type === 'comment') {
        notificationType = 'iconf-comment';
      } else if (type === 'certificate') {
        notificationType = 'iconf-medal';
      }

      notificationType = type === 'course' ? 'iconf-play' : notificationType;

      return notificationType;
    },
    blockMenu(state) {
      if (state) {
        this.isActiveMenu = true;
      } else {
        this.isActiveMenu = false;
      }
    },
    unblockMenu() {
      if (!this.isActiveMenu) {
        this.switcher = false;
      }
    },
    getNotifications() {
      this.isLoading = true;

      const params = `?notificationIds=${this.currentNotificationsIds}&perPage=${this.pagination.perPage}`;
      const url = `${window.arcux.site}/api/v1/users/${this.body.id}/notifications/${params}`;

      fetch(url, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((data) => {
          const yesterday = (Math.round((new Date().getTime()) / 1000)) - (24 * 3600);
          const recents = data.list.filter((item) => yesterday < item.timestamp);
          const ancients = data.list.filter((item) => yesterday > item.timestamp);

          this.recents = [...recents, ...this.recents];
          this.ancients = [...this.ancients, ...ancients];

          this.currentNotificationsIds += `${data.list.map((item) => item.id).toString()},`;

          if (data.list.length < 10) { this.hasMoreNotifications = false; }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    readNotification(notification) {
      const url = `${window.arcux.site}/api/v1/users/${this.body.id}/notifications/${notification.id}/observe/`;

      fetch(url, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then(() => {
          window.location.href = notification.action;
        })
        .catch((err) => {
          throw err;
        });
    },
    handleScroll(e) {
      if (this.requestNotificationsState !== 'waiting' && this.requestNotificationsState !== 'disabled') {
        if (
          this.hasMoreNotifications
          && !this.isLoading
          && e.target.getBoundingClientRect().height
            > (this.$refs.loader.getBoundingClientRect().top - 50)
        ) {
          this.getNotifications();
        }
      }
    },
  },
};
</script>
